import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';


@Component({
  selector: 'app-wizard-variable',
  templateUrl: './wizard-variable.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-variable.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardVariableComponent extends WizardHpBaseComponent implements OnInit {
  @Input() varItem;
  
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
 
  getVarIsInvalid(varItem : any) {

    var result = false;
    var min = varItem.var_min_val;
    var max = varItem.var_max_val;
    var obligatoire = varItem.var_obligatoire;
    var val = varItem.var_value;

    if (!result) {
      if (obligatoire && (val == null || val == '')) {
        result = true;
      }
    }

    if (!result) {
      if (min != null && min != '') {

        result = true;
        var mn = parseFloat(min);
        var cn = parseFloat(val);
        if (cn >= mn) {
          result = false;
        }
      }
    }
    if (!result) {
      if (max != null && max != '') {
        result = true;
        var mn = parseFloat(max);
        var cn = parseFloat(val);
        if (cn <= mn) {
          result = false;
        }
      }
    }

    return result;
  }

}
